var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable max-len */
import React from "react";
import BaseSvgIcon from "../Base";
var SpeechPlus = function (props) {
    return (React.createElement(BaseSvgIcon, __assign({}, props, { viewBox: "0 0 17 19" }),
        React.createElement("g", null,
            React.createElement("path", { d: "M9.5,17.0166 L9.5,13.4996 L8.5,13.4996 C4.225,13.4996 1,10.9206 1,7.4996 C1,3.9156 4.364,0.9996 8.5,0.9996 C12.636,0.9996 16,3.9156 16,7.4996 C16,15.0376 11.159,16.6766 9.5,17.0166 M8.5,-0.0004 C3.813,-0.0004 0,3.3646 0,7.4996 C0,11.4906 3.654,14.4996 8.5,14.4996 L8.5,18.1416 L9.04,18.0976 C9.119,18.0916 17,17.3476 17,7.4996 C17,3.3646 13.187,-0.0004 8.5,-0.0004" }),
            React.createElement("path", { d: "M11.5,7 L9,7 L9,4.5 C9,4.224 8.776,4 8.5,4 C8.224,4 8,4.224 8,4.5 L8,7 L5.5,7 C5.224,7 5,7.224 5,7.5 C5,7.776 5.224,8 5.5,8 L8,8 L8,10.5 C8,10.776 8.224,11 8.5,11 C8.776,11 9,10.776 9,10.5 L9,8 L11.5,8 C11.776,8 12,7.776 12,7.5 C12,7.224 11.776,7 11.5,7" }))));
};
export default SpeechPlus;
